(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${
        this.header.offsetHeight
      }px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  document.addEventListener('DOMContentLoaded', function() {
    if (window.matchMedia('(max-width: 990px)')) {
}
      else {
    
  // Hover effect for blocks
  const blocks = document.querySelectorAll('.mega-menu-block');
  blocks.forEach(block => {
    console.log(block, 'these r  the blocks');
          const menuId = blocks.getAttribute('data-menu').toLowerCase();
          const matchingMenuItem = document.querySelector(`[id*="data-menu-]`);
       
          if (matchingMenuItem) {
              // Apply hover effect to the matching menu item
              matchingMenuItem.classList.add('hover-effect');
          }

  });
      }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const firstMenuItem = document.querySelector('.first-menu-item');
    const detailsElement = document.querySelector('details-disclosure, header-menu');

    function toggleMegaMenu() {
        // Assuming toggleOpen() method intelligently handles both open and close actions
        if (detailsElement && typeof detailsElement.toggleOpen === 'function') {
            detailsElement.toggleOpen();
        } else {
            // Fallback manual toggle if the custom method is not found
            const isOpen = detailsElement.mainDetailsToggle.hasAttribute('open');
            if (isOpen) {
                detailsElement.close(); // Close if open
            } else {
                detailsElement.mainDetailsToggle.setAttribute('open', ''); // Open if closed
            }
        }
    }

    if (firstMenuItem) {
        firstMenuItem.addEventListener('click', function(event) {
            event.preventDefault();
            toggleMegaMenu();
        });
    }

    // Close the mega menu when clicking outside
    document.addEventListener('click', function(event) {
        const isClickInside = detailsElement.contains(event.target) || firstMenuItem.contains(event.target);

        if (!isClickInside && detailsElement.mainDetailsToggle.hasAttribute('open')) {
            detailsElement.close();
        }
    });

    // Prevent the document click from triggering when clicking inside the menu
    if (detailsElement) {
        detailsElement.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    }
});




  } catch(e) { console.error(e); }
})();
})();
